// extracted by mini-css-extract-plugin
export default {"mismatchInfoBox":"ProofOfAddressMismatchInfoBox__mismatchInfoBox-wfgo","mismatchInfoAndErrorBox":"ProofOfAddressMismatchInfoBox__mismatchInfoAndErrorBox-nDF5"};